import { PopupConfirmation } from './components/common/order/popup/popupConfirmation'
import { PopupAlertError } from './components/common/popup/PopupAlertError'
import { PopupShowPdf } from './components/common/popup/PopupShowPdf'
import { PopupBuyReport } from './components/common/popup/popupBuyReport'
import { PopupUpgrade } from './components/common/popup/popupUpgrade'
import { PopupSessionExpired } from './components/common/popup/sessionExpired'

export const RootPopup = () => {
  return (
    <>
      <PopupAlertError />
      <PopupUpgrade />
      <PopupSessionExpired />
      <PopupBuyReport />
      <PopupConfirmation />
      <PopupShowPdf />
    </>
  )
}
